import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

export const StyledDatagrid = styled(Datagrid)({
  '& .column-id': getColumnStyle(73),
  '& .column-name': getColumnStyle(178),
  '& .column-tresholds': { ...getColumnStyle(108), textAlign: 'center' },
});
